import React from 'react';
import './style';
import { Button, Modal , Accordion} from 'app/components';
import { 
  WhatsappLogo,
} from '@phosphor-icons/react';

import { questions } from '../mockdata';

const Questions = (props) => {
  const { 
    handleModalClose,
  } = props;

  const handleClick = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const mobileAgents = /iphone|ipad|android/;
    let isMobile = mobileAgents.test(userAgent);
    let whatsappurl = '';
    const phoneNumber = '9025082101';

    if (isMobile) {
      whatsappurl = `https://wa.me/91${phoneNumber}`;
      window.open(whatsappurl);
    } else {
      whatsappurl = `https://web.whatsapp.com/send?phone=${phoneNumber}`;
      window.open(whatsappurl, '_blank');
    }
  };

  return (
    <Modal 
      size="regular"
      className="faq-modal"
      hasClose ={true}
      onClose={handleModalClose}
      title="Questions?"
    >
      <div className='flex flex-col gap-7'>
          {questions.map((question, index) => {
            return (
              <Accordion
                width="100%"
                content={question.content}
                title={question.title}
                key={index}
              />
            )
          })}
        <div className='flex flex-col gap-5 mt-8'>
          <div className='flex flex-col gap-2'>
            <h1 className="text-lg font-medium">Talk to us</h1>
            <p className="text-16">We’re always looking to improve the experience for you.</p>
          </div>
          <div className='flex flex-col gap-2 justify-center'>
            <Button className="w-full"
              type="primary-black"
              iconRight={<WhatsappLogo weight='fill'/>} onClick={handleClick}>Get in touch</Button>
            {/* <Button className="w-full"
              type="tertiary">Book a call</Button> */}
          </div>
        </div>
      </div>
    </Modal>
  )

}

export default Questions;